import React from 'react';
import { motion } from 'framer-motion';
import { FiSearch, FiSettings, FiBarChart, FiShield } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const processes = [
  {
    title: "Local Market Audit",
    desc: "We analyze your competitors in Calgary or Edmonton to identify exactly what keywords they are winning and where they are vulnerable.",
    icon: FiSearch,
    color: "bg-blue-500"
  },
  {
    title: "GBP Optimization",
    desc: "Your Google Business Profile is your storefront. We optimize every pixel to ensure you appear in the top 3 Map Pack results.",
    icon: FiSettings,
    color: "bg-orange-500"
  },
  {
    title: "Authority Building",
    desc: "We build local citations and high-quality backlinks from Alberta-based directories to establish your business as a local leader.",
    icon: FiShield,
    color: "bg-green-500"
  },
  {
    title: "Revenue Tracking",
    desc: "We don't just track rankings. We track calls, form fills, and actual revenue generated from your local search presence.",
    icon: FiBarChart,
    color: "bg-purple-500"
  }
];

const ProcessSection = () => {
  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">The Alberta Local SEO Roadmap</h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            A proven, four-step framework designed specifically for Alberta home service contractors.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {processes.map((item, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
              className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 relative overflow-hidden group"
            >
              <div className={`w-12 h-12 ${item.color} text-white rounded-xl flex items-center justify-center mb-6 shadow-lg`}>
                <SafeIcon icon={item.icon} className="text-xl" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{item.title}</h3>
              <p className="text-slate-600 text-sm leading-relaxed">{item.desc}</p>
              <div className="absolute -bottom-2 -right-2 text-6xl font-black text-slate-50 group-hover:text-slate-100 transition-colors">
                0{i + 1}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;